import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export default {
  namespaced: true,
  state() {
    return {
      // selected disk
      selectedDisk: null,

      // We now have a concept of root directory for this manager instance.
      rootDirectory: null,

      // selected directory
      selectedDirectory: null,

      meta: {
        status: null,
        message: null,
        path: null,
        disk: null,
        group: null,
        root: false,
        listing: false,
      },

      // Directories in the selected directory
      directories: [],

      listings: [],

      // files in the selected directory
      files: [],

      // selected files and folders
      selected: {
        directories: [],
        files: [],
      },

      // sorting settings
      sort: {
        field: 'name',
        direction: 'up',
      },

      // history
      history: [null],

      // history pointer
      historyPointer: 0,

      // view type - table or grid - (default - table)
      viewType: 'table',

      targetFile: null,
      targetFolder: null,
    };
  },
  mutations,
  getters,
  actions,
};
